import { SelectionModel } from '@angular/cdk/collections';
import {trigger, transition, style, animate,} from "@angular/animations";
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Optional, ViewChild, ViewChildren, ViewRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { TokenStorage } from '../../../../../../../core/auth/_services/token-storage.service';
import { LayoutUtilsService } from '../../../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../../../core/_base/layout';
import { FunctionPublic } from '../../../../dung-chung/__function/common_function';
import { CommonConFig } from '../../../../dung-chung/__model/common_config.model';
import { DungChungService } from '../../../../dung-chung/__services/dung-chung.service';
import { KeHoachMuaHang } from '../../../ke-hoach-mua-hang/ke-hoach-mua-hang-model/ke-hoach-mua-hang.model';
import { DeNghiMuaHang, DeNghiMuaHangCT, FileImport } from '../de-nghi-mua-hang-page-model/de-nghi-mua-hang-page.model';
import { DeNghiMuaHangPageService } from '../de-nghi-mua-hang-page-service/de-nghi-mua-hang-page.service';
import { LichSuMuaHangDialogComponent } from '../lich-su-mua-hang-list-dialog/lich-su-mua-hang-list-dialog.component';
import { LichSuNhanHangDialogComponent } from '../lich-su-nhan-hang-list-dialog/lich-su-nhan-hang-list-dialog.component';
import { NguyenLieuService } from 'app/views/pages/nfc/nguyen-lieu/nguyen-lieu-service/nguyen-lieu.service';
import { KDDatHangEditComponent } from 'app/views/pages/nfc/kinh-doanh/kd-dat-hang/kd-dat-hang-edit/kd-dat-hang-edit.component';
import { ConstantPurchaseOrder, KDDatHang } from 'app/views/pages/nfc/kinh-doanh/kd-dat-hang/kd-dat-hang-model/kd-dat-hang.model';
import { LichSuGiaMuaHangComponent } from '../../../don-hang-mua/lich-su-gia-mua-hang/lich-su-gia-mua-hang.component';
import { DonHangMuaEditComponent } from '../../../don-hang-mua/don-hang-mua-page-edit/don-hang-mua-edit.component';
import { DonHangMuaDialogDetailComponent } from '../../../don-hang-mua/don-hang-mua-dialog-detail/don-hang-mua-dialog-detail.component';

@Component({
	selector: 'm-de-nghi-mua-hang-page-detail',
	templateUrl: './de-nghi-mua-hang-page-detail.component.html',
	styleUrls: ['../de-nghi-mua-hang-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe],
	animations: [
		trigger(
		  'addAnimation', [
			transition(':enter', [
			  style({transform: 'translateX(100%)', opacity: 0}),
			  animate('800ms', style({transform: 'translateX(0)', opacity: 1, 'overflow-x': 'hidden'}))
			]),
			transition(':leave', [
			  style({transform: 'translateX(0)', opacity: 1}),
			  animate('800ms', style({transform: 'translateX(100%)', opacity: 0}))
			])
		  ]
		),
	]
})

export class DeNghiMuaHangPageDetailComponent implements OnInit {

	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChild('fileUploadImport', { static: false }) fileUploadImport: ElementRef;
	@ViewChild('fileUpload', { static: true }) fileUpload;
	@ViewChildren('focusDetail') focusDetail;

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/


	/*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
		// {
		// 	stt: 0,
		// 	name: 'select',
		// 	displayName: 'Check chọn',
		// 	alwaysChecked: true,
		// 	isShow: true
		// },
		{
			stt: 2,
			name: 'MaHang',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SoLuong',
			displayName: 'SL',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'MOQ',
			displayName: 'MOQ',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'NgayCanTu',
			displayName: 'Ngày cần từ ngày',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'NgayCanDen',
			displayName: 'Ngày cần đến ngày',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'GiaDuKien',
			displayName: 'Giá dự kiến (VND)',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'ThanhTien',
			displayName: 'Thành tiền',
			alwaysChecked: false,
			isShow: true
		},
		
		{
			stt: 7,
			name: 'PBSD',
			displayName: 'Phòng ban sử dụng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'BPSD',
			displayName: 'Bộ phận sử dụng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'TenFileGoc',
			displayName: 'File đính kèm thông tin hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'GhiChu',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'FileTieuChuan',
			displayName: 'File tiêu chuẩn hàng hóa',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'TenNguoiDuyet',
			displayName: 'Người duyệt',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'NgayDuyet',
			displayName: 'Ngày duyệt',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 14,
			name: 'isDuyet',
			displayName: 'Kết quả',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'LyDoDuyet',
			displayName: 'Lý do',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 16,
			name: 'TrangThaiDapUng',
			displayName: 'Trạng thái',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 17,
			name: 'SoLuongDapUng',
			displayName: 'SL đáp ứng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 18,
			name: 'GhiChuDapUng',
			displayName: 'Ghi chú đáp ứng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	/* ------------------------------------------------------------------*/


	/*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH: any[] = [];
	selectId_HH: string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	sumRecord = 0;
	// Filter loại hàng hóa
	listLoaiHH: any[] = [];
	selectLoaiHH: string = '';
	filteredLoaiHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	LoaiHHFilterCtrl: string = '';
	haveElementLoaiHH: boolean = false;
	/* ------------------------------------------------------------------*/


	/*------------------------ Danh sách trạng thái ----------------------*/
	listState: any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách phòng ban -----------------------*/
	listPB: any[] = [];
	PBUser: string = '';
	selectPB: string = '';
	filteredPB: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	PBFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách NCC -----------------------------*/
	listNCC: any[] = [];
	selectListNCC: string = '';
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = '';
	haveElementListNCC: boolean = false;
	arrayNCCForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */


	/*--------------------- Danh sách bộ phận sự dụng --------------------*/
	listPBSD: any[] = [];
	selectListPBSD: string = '';
	filteredListPBSD: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListPBSDFilterCtrl: string = '';
	haveElementListPBSD: boolean = false;
	arrayPBSDForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiMuaHangCT>(true, []);
	/* ------------------------------------------------------------------ */


	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */


	/* ------------------- Các form trên dialog --------------------------*/
	DeNghiMuaHangForm: FormGroup;
	DeNghiMuaHangSubForm: FormGroup;
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	deNghiMuaHangItem: DeNghiMuaHang;
	listChiTietMuaHang: DeNghiMuaHangCT[] = [];
	tmpChiTietMuaHang: DeNghiMuaHangCT[] = [];
	flagFileImport: FileImport = new FileImport();
	flagFileDownload: any;
	/* ------------------------------------------------------------------ */


	/*------------------------- Extend field: ----------------------------*/
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	saveAddedCT: number[] = []
	viewLoading: boolean = false;   	// Loading khi mở dialog
	disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	processImport: boolean = false;		// Có đang chạy import
	flagTab: number = 0;				// Định danh tab đang chạy
	openTimKiemNangCao = false;
	waittingAddDetail = false;
	optionsLoaiPhieu: any[] = [];
	optionTTDetail: any[] = [];
	optionsTinhTrang: any[] = [];
	isCopy: boolean = false;
	isVuotHanMucPB: boolean = false;
	isVuotHanMucDuyet: boolean = false;
	isExistHM: boolean = false;
	isExistHMDuyet: boolean = false;
	hanMucPB: string = '';
	hanMucDuyetPB: string = ''
	haveDataKHMH: boolean = false;
	listDataKeHoachMuaHang: KeHoachMuaHang[] = [];
	idPBMuaHang: number = 0;
	waittingExport: boolean = false;
	route = '';
  referPOList: any[] = [];
  poDialogRef: any = null;
	/* ------------------------------------------------------------------ */

	constructor(
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		@Optional() public dialogRef: MatDialogRef<DeNghiMuaHangPageDetailComponent>,
		private deNghiMuaHangService: DeNghiMuaHangPageService,
		private dungChungService: DungChungService,
		private DeNghiMuaHangFB: FormBuilder,
		private DeNghiMuaHangSubFB: FormBuilder,
		public dialog: MatDialog,
		private router: Router,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private activatedRoute: ActivatedRoute,
		private nguyenLieuService: NguyenLieuService,
	) { }

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		this.route = window.location.origin;

		/*Load all dropdown and create form */
		this.ListState();
		this.getIdPBMuaHang();
		this.ListLoaiHH();
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.deNghiMuaHangItem = new DeNghiMuaHang();
		this.deNghiMuaHangItem.clear();
		this.optionsLoaiPhieu = DeNghiMuaHang.optionsLoaiPhieu;
		this.optionTTDetail = DeNghiMuaHangCT.optionTrangThaiDetail;
		this.optionsTinhTrang = DeNghiMuaHang.optionsTinhTrang;

		this.createForm();

		this.activatedRoute.params.subscribe(params => {
			let id = +params.id;
			if(this.data != null){
				id = this.data;
			}
			if ((id && id > 0)) {
				this.deNghiMuaHangItem.Id = id;
				this.deNghiMuaHangService.getDetail(this.deNghiMuaHangItem.Id).subscribe(res => {
					if (res.status == 1) {
						this.deNghiMuaHangItem = res.data
						if (this.DeNghiMuaHangForm != null) {
							this.deNghiMuaHangService.getReferences(this.deNghiMuaHangItem.Id).subscribe(res => {
								if (res && res.status === 1 && res.data) {
									const { PurchaseOrders = [] } = res.data;
									this.referPOList = PurchaseOrders.map(({ Id, Code }) => ({ Id, Code }));
									this.changeDetect.detectChanges();
								}
							});
							this.bindingValueAfterCallAPIDetail();
						}
					}
				});
			} else {
				this.deNghiMuaHangItem.TinhTrang = DeNghiMuaHang.optionsTinhTrang[0].value;
				this.dungChungService.getBillNumber(DeNghiMuaHang.category_path).subscribe(res => {
					if (res.status == 1) {
						this.deNghiMuaHangItem.SoPhieu = res.data;
						if (this.DeNghiMuaHangForm != null)
							this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(this.deNghiMuaHangItem.SoPhieu);
					}
				});
			}
		});

		this.title = this.getTitle();

		let breadcrumbs = [{ title: 'Thu mua' }, { title: 'Đề nghị mua hàng', page: '/de-nghi-mua-hang' }, { title: 'Chi tiết phiếu đề nghị mua hàng' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Create Form with appropriate sub forms ---------------*/
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.deNghiMuaHangItem.Nguoitao = +idUser;

		this.DeNghiMuaHangForm = this.DeNghiMuaHangFB.group({
			SoPhieu: ['', Validators.required],
			NgayLapPhieu: [new Date(), Validators.required],
			TenNguoiLap: [tenNguoiLap],
			TrangThai: [this.nameState, Validators.required],
			LoaiPhieu: [DeNghiMuaHang.optionsLoaiPhieu[0].value, Validators.required],
			DienGiai: ['', Validators.required],
			TongTien: [DeNghiMuaHang.DEFAULT_NUMBER_VALUE],
			LoaiHH: ['', Validators.required],

		});

		if (this.listState.length > 0) {
			this.checkState();
		}

		/*Disable các trường dữ liệu không thay đổi */
		this.DeNghiMuaHangForm.disable();
		/*------------------------------------------------------------------*/

		this.changeDetectView();
	}
	bindingValueAfterCallAPIDetail() {
		if (this.deNghiMuaHangItem.Id > 0) {
			if (!this.isCopy) {
				this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(this.deNghiMuaHangItem.SoPhieu);
			}
			else {
				this.deNghiMuaHangItem.Id = 0;
				this.deNghiMuaHangItem.TinhTrang = DeNghiMuaHang.optionsTinhTrang[0].value;
				this.deNghiMuaHangItem.listChiTietMuaHang.forEach(x => {
					x.Id = 0;
					x.PhieuDeNghiId = 0;
					x.DaLapDonHang = false;
					x.DaNhanHang = false;
					x.TrangThaiMatHang = DeNghiMuaHangCT.optionTrangThaiDetail[0].value
				})

				this.dungChungService.getBillNumber(DeNghiMuaHang.category_path).subscribe(res => {
					if (res.status == 1) {
						this.deNghiMuaHangItem.SoPhieu = res.data;
						if (this.DeNghiMuaHangForm != null)
							this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(this.deNghiMuaHangItem.SoPhieu);
					}
				});
			}

			this.DeNghiMuaHangForm.controls["NgayLapPhieu"].setValue(this.deNghiMuaHangItem.NgayYeuCau);
			this.DeNghiMuaHangForm.controls["TenNguoiLap"].setValue(this.deNghiMuaHangItem.TenNguoiTao);
			this.DeNghiMuaHangForm.controls["LoaiPhieu"].setValue(this.deNghiMuaHangItem.LoaiPhieu);
			this.DeNghiMuaHangForm.controls["DienGiai"].setValue(this.deNghiMuaHangItem.DienGiaiLyDo);
			this.DeNghiMuaHangForm.controls["LoaiHH"].setValue(this.deNghiMuaHangItem.LoaiHangHoaYeuCau.toString());
			this.checkState();

			/*Add dữ liệu chi tiết*/
			if (this.deNghiMuaHangItem.listChiTietMuaHang.length > 0) {
				this.listChiTietMuaHang = this.deNghiMuaHangItem.listChiTietMuaHang;
				this.tmpChiTietMuaHang = [];

				var tenNguoiLap = '';
				this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
				for (let i = 0; i < this.listChiTietMuaHang.length; i++) {
					if (this.listChiTietMuaHang[i].SoLuongDaMua == null) {
						this.listChiTietMuaHang[i].SoLuongDaMua = 0;
					}
					if (this.listChiTietMuaHang[i].SoLuongDaNhan == null) {
						this.listChiTietMuaHang[i].SoLuongDaNhan = 0;
					}
					let tmpElement = new DeNghiMuaHangCT();
					tmpElement.copy(this.listChiTietMuaHang[i])
					this.deNghiMuaHangService.getMOQ(tmpElement.HangHoaId).subscribe(res => {
						if (res && res.status === 1) {
							tmpElement.listMOQ = res.data;
						};
					});
					this.tmpChiTietMuaHang.push(tmpElement);

				}
				this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
				this.updateTT();
			}
		}
		console.log(this.deNghiMuaHangItem);
		console.log(this.tmpChiTietMuaHang)
	}
	getTitle(): string {
		return 'Chi tiết phiếu đề nghị mua hàng';
	}
	getHistory(idDetail: any, type: number) {
		let item = this.getItemDuyet(idDetail);
		if (item == null) {
			item = this.getItemKODuyet(idDetail);
		}

		if (item != null && type == 0) {
			return item.NoiDung == "True" ? "Duyệt" : "Không duyệt"
		}
		else if (item != null && type == 1) {
			return item.GhiChu;
		}
		else if (item != null && type == 2) {
			return item.TenNguoiThaoTac;
		}
		else if (item != null && type == 3) {
			return item.NgayThaoTac;
		}
		return '';
	}
	getItemDuyet(idDetail: any) {
		let item = this.deNghiMuaHangItem.listPhieuDeNghiLsThaoTac.find(x => x.PhieuDeNghiCtId == idDetail
			&& x.LoaiThaoTac == DeNghiMuaHangCT.optionTrangThaiDetail[3].value)
		return item;
	}
	getItemKODuyet(idDetail: any) {
		let item = this.deNghiMuaHangItem.listPhieuDeNghiLsThaoTac.find(x => x.PhieuDeNghiCtId == idDetail
			&& x.LoaiThaoTac == DeNghiMuaHangCT.optionTrangThaiDetail[5].value)
		return item;
	}
	/* -----------------------------------------------------------------------*/


	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	getNumOfCanSelected() {
		var count = 0;
		this.tmpChiTietMuaHang.forEach(x => {
			if ((x.TrangThaiMatHang == DeNghiMuaHangCT.optionTrangThaiDetail[3].value)
				&& x.DaNhanHang == false) {
				count++;
			}
		})
		return count;
	}
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.getNumOfCanSelected();
		return numSelected === numRows;
	}
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpChiTietMuaHang.forEach(row => {
				if ((row.TrangThaiMatHang == DeNghiMuaHangCT.optionTrangThaiDetail[3].value)
					&& row.DaNhanHang == false) {
					this.selection.select(row)
				}
			});
		}
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListLoaiHH() {
		
		this.dungChungService.listLoaiHH().subscribe(res => {
			// this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listLoaiHH = res.data;
				this.filteredLoaiHH.next(this.listLoaiHH.slice());
				this.changeDetect.detectChanges();
			};
		});
	}
	ListState() {
		this.dungChungService.listState(DeNghiMuaHang.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState() {
		this.listState.forEach(element => {
			if (element.Code == this.deNghiMuaHangItem.TinhTrang) {
				this.nameState = element.Description;
				if (this.DeNghiMuaHangForm != null)
					this.DeNghiMuaHangForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}

	ListId_HH() {
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	ListPB() {
		this.dungChungService.listPhongBanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listPBSD = res.data;
				this.filteredListPBSD.next(this.listPBSD.slice());
				this.changeDetectView();
			};
		});
	}
	getIdPBMuaHang() {
		this.deNghiMuaHangService.getConfigDefaultPB().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.idPBMuaHang = res.data;
				this.changeDetectView();
			};
		});
	}
	checkDKGetHMPB() {
		if (this.DeNghiMuaHangForm.controls["LoaiPhieu"].value == DeNghiMuaHang.optionsLoaiPhieu[0].value) {
			return false;
		}
		return true;
	}
	updateTT() {
		let sum = 0;
		this.tmpChiTietMuaHang.forEach(x => {
			sum += Number(x.ThanhTien);
		})
		this.DeNghiMuaHangForm.controls['TongTien'].setValue(this.f_number(sum));
	}
	/* -----------------------------------------------------------------------*/


	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string) {
		let message = "";
		let controls = formGroup.controls;
		if (controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if (controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return DeNghiMuaHang.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}

			} else {
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!controls[controlName].invalid) {
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else {
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event: any, min: number = 0) {

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiMuaHangCT) {

		if (event.target.value == "") {
			event.target.value = this.f_number(0);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (event.target.value.toString() == item[columnName].toString()) {
			event.target.value = this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}

			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
		if (v != null && v != undefined && v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	compareDate(firstVal: any, secondVal: any) {
		if (firstVal != null && firstVal != undefined && secondVal != null && secondVal != undefined) {
			let d1 = new Date(firstVal);
			let d2 = new Date(secondVal);
			if (d1.getTime() > d2.getTime())
				return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*---------------------------- Thao tác trên form ------------------------*/
	back() {
		this.router.navigateByUrl('de-nghi-mua-hang', { relativeTo: this.activatedRoute });
	}
	close() {
		this.dialogRef.close();
	}
	isCreate() {
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		if (this.deNghiMuaHangItem != null && (this.deNghiMuaHangItem.Nguoitao == +idUser)) {
			return true;
		}
		return false;
	}
	dongDeNghi() {
		if (this.selection.selected.length <= 0) {
			this.layoutUtilsService.showErorr('Vui lòng chọn dữ liệu cần đóng đề nghị');
			return;
		}

		const dialogRef = this.layoutUtilsService.POP02('');
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}

			this.deNghiMuaHangService.dongDeNghi(this.selection.selected).subscribe(res => {
				if (res.status == 1) {
					const message = 'Cập nhật thành công';
					this.layoutUtilsService.showInfo(message);

					this.selection.selected.forEach(row => {
						row.DaNhanHang = true;
						row.TrangThaiMatHang = DeNghiMuaHangCT.optionTrangThaiDetail[4].value
					})
					this.selection.clear();
					this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
					this.changeDetectView();
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
		});
	}
	openHistoryMuaHangDialog(item: DeNghiMuaHangCT) {
		const dialogRef = this.dialog.open(LichSuMuaHangDialogComponent, {
			data: {
				data: item.Id,
				MaHH: item.MaHang,
				TenHH: item.TenHang
			},
			width: '60%'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
		});
	}
	openHistoryNhanHangDialog(item: DeNghiMuaHangCT) {
		const dialogRef = this.dialog.open(LichSuNhanHangDialogComponent, {
			data: {
				data: item.Id,
				MaHH: item.MaHang,
				TenHH: item.TenHang
			},
			width: '60%'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
		});
	}
	openLichSuGiaMuaHang(item: DeNghiMuaHangCT) {
		const dialogRef = this.dialog.open(LichSuGiaMuaHangComponent, {
			data: {
				IdHH: item.HangHoaId,
				Ma_Ten_HH: item.MaHang + " - " + item.TenHang,
        estimatedPrice: item.GiaDuKien
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe(res => {

		});
	}
	callDetail() {
		var item: any = {};
		item.IdDH = this.tmpChiTietMuaHang[0].IdPO;
		item.Type = ConstantPurchaseOrder.OPTION_PURCHASEORDER;
		const dialogRef = this.dialog.open(KDDatHangEditComponent, {
			data: {
				data: item,
				chi_tiet: true,
				model: this.tmpChiTietMuaHang[0].LoaiPhieuPO
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe();
	}
	/* -----------------------------------------------------------------------*/


	/*--------------------------- Hàm xử lý File------------------------------*/
	downloadFile(idctdn: number, item: DeNghiMuaHangCT) {
		if (idctdn > 0) {
			let linkdownload = this.deNghiMuaHangService.downloadTemplate(idctdn);
			window.open(linkdownload);
		}
		else {
			let objectURL;
			const file = item.fileTmpDownLoad;
			objectURL = URL.createObjectURL(file);
			var downloadLink = document.createElement("a");
			downloadLink.href = objectURL;
			downloadLink.download = file.name;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		}

	}
	downloadFileTieuChuan(idHH: number) {
		if (idHH > 0) {
			let linkdownload = this.nguyenLieuService.downloadTCNPL(idHH);
			window.open(linkdownload);
		}
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom() {
		setTimeout(() => {
			window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
		}, 200);
	}
	highlightNewestRecord(currentPosition: number) {
		if (this.saveAddedCT.findIndex(x => x == currentPosition) > -1) {
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------------- Export excel & print ------------------------*/
	ExportFileExcel() {
		this.deNghiMuaHangService.exportFileExcel(this.deNghiMuaHangItem.Id).subscribe(blob => {
			var downloadLink = document.createElement("a");
			var url = URL.createObjectURL(blob);
			downloadLink.href = url;
			downloadLink.download = `EXPORT_${this.deNghiMuaHangItem.SoPhieu}_${moment(new Date).format('YYYYMMDDHHmm')}`;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
			this.waittingExport = false;
			this.changeDetectView();
		});
	}
	/* -----------------------------------------------------------------------*/

  goToPurchaseOrder(poId: number) {
    if (this.poDialogRef && this.poDialogRef.close) {
      this.poDialogRef.close();
    }
    this.poDialogRef = this.dialog.open(DonHangMuaEditComponent, {
      data: { id: poId },
      maxHeight: "95vh",
			width: "95vw",
    });
    this.poDialogRef.afterClosed().subscribe(() => {
      this.poDialogRef = null;
    });
  }
}